/* Les petits mots ne font pas d'initiale : « GAEC du Bousquet » → « GB », pas « GD ». */
const PETITS_MOTS = new Set(['de', 'du', 'des', 'la', 'le', 'les', 'et', 'd', 'l', 'en', 'sur']);

/** Les initiales d'un nom (« Claire Martin » → « CM »), ou de l'adresse à défaut. */
export function initiales(nom: string, repli = '?'): string {
  const mots = nom
    .trim()
    .split(/[\s@._'’-]+/)
    .filter(Boolean);
  if (mots.length === 0) return repli;
  const significatifs = mots.filter((m) => !PETITS_MOTS.has(m.toLowerCase()));
  const [premier, second] = significatifs.length > 0 ? significatifs : mots;
  return ((premier?.[0] ?? '') + (second?.[0] ?? '')).toUpperCase() || repli;
}
